export const serverUrls = {
    "authUrl": import.meta.env.VITE_APP_BACKEND_URL
}
